import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/traffic-green.png'
import _imports_1 from '@/assets/images/traffic-red.png'
import _imports_2 from '@/assets/images/traffic-amber.png'


const _withScopeId = n => (_pushScopeId("data-v-8c91b496"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light booking-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-9" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "What & When")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Post code", -1))
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Address", -1))
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  style: {"color":"transparent"}
}, ".", -1))
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Town", -1))
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "County", -1))
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Job Type", -1))
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Internal Job Type", -1))
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Date", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "card mt-3 darker-grey-background" }
const _hoisted_31 = { class: "card-body mb-3" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Bedrooms", -1))
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Bathrooms", -1))
const _hoisted_39 = { class: "col-md-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Receptions", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Other", -1))
const _hoisted_42 = { class: "row" }
const _hoisted_43 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_44 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 pl-0" }, null, -1))
const _hoisted_46 = { class: "col-md-2 pr-0" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Floorplan", -1))
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Square feet", -1))
const _hoisted_51 = { class: "col-md-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Property type", -1))
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Furnish", -1))
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = { class: "dx-field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Provisional", -1))
const _hoisted_60 = { class: "dx-field-value" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_64 = {
  key: 1,
  class: "col-form-label"
}
const _hoisted_65 = { class: "col-md-4" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "previousreportdetails" }
const _hoisted_68 = { class: "text-flex" }
const _hoisted_69 = { class: "ml-1" }
const _hoisted_70 = { class: "text-flex" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date :", -1))
const _hoisted_72 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "text-flex" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ref :", -1))
const _hoisted_76 = { class: "ml-1" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " General Notes :", -1))
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "previousreportdetails" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Previous report details:", -1))
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1))
const _hoisted_88 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Upload report details:", -1))
const _hoisted_90 = {
  key: 0,
  style: {"padding-left":"10px"}
}
const _hoisted_91 = { key: 0 }
const _hoisted_92 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Email to dataentry:", -1))
const _hoisted_94 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Send email to data entry"
}
const _hoisted_95 = {
  key: 0,
  class: "trafficlight",
  src: _imports_0
}
const _hoisted_96 = {
  key: 1,
  class: "trafficlight",
  src: _imports_1
}
const _hoisted_97 = {
  key: 2,
  class: "trafficlight",
  src: _imports_2
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-history" }, null, -1))
const _hoisted_99 = [
  _hoisted_98
]

import {
  computed,
  onMounted,
  ref,
  inject,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import moment from "moment-timezone";
import { postfixUTCTime } from "@/utilities";
import { convert, convertcommon } from "@/bookingconverters";
import { DxSwitch } from "devextreme-vue/switch";

import {
  Booking,
  Report,
  Room,
  Section,
  Type,
  Address,
  PropertySpec,
  GetaddressResponse,
  SearchAddressResponse,
  Inspector,
  Fee,
  DictionaryReportType,
  EmailLog,
  PresetError,
Tenant,
} from "@/models";

import { DxDateBox, DxButton as DxDateBoxButton } from "devextreme-vue/date-box";
import FloorplanComponent from "@/components/floorplan/Floorplans.vue";
import Documents from "@/components/document/Documents.vue";
import { useToast } from "vue-toastification";

import PostcodeReportSearchModal from "@/components/modals/PostcodeReportSearchModal.vue";
import AlertDialog from "@/components/modals/AlertDialog.vue";
import ProgressButton from "@/components/ProgressButton.vue";
import BookingDetailModal from "@/components/modals/BookingDetailModal.vue";

import { DxTooltip } from "devextreme-vue/tooltip";
import Ably from "ably";

import EmailModal from "@/components/modals/EmailModal.vue";
import EmailLogsModal from "@/components/modals/EmailLogsModal.vue";
import index from "../index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WhatWhen',
  emits: ["showfloorplandocument", "showdataentrydocument"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store = useStore();
const route = useRoute();
const router = useRouter();
const toasted = useToast();
const expanded = ref(false);

const realtime: Ably.Realtime = inject("realtime");
const actProperty: any = inject("actProperty");
const channel = realtime.channels.get("diary");
const deviceid = actProperty.getDeviceId();

const dataentryconfirmationEmailModal = ref(null);
const dataentryconfirmationEmailLogsModal = ref(null);
const alertDialog = ref(null);
const cmsSearchModal = ref(null);
const otherroomstooltip = ref(null);

const dynamicRefs = ref({});
const bookingDetailModal = ref(null);

const hasUnsavedChanges = computed(
  () => store.getters["diary/hasUnsavedChanges"]
);
const dictionary = computed(() => store.getters["dictionary/current"]);
const isQCuser = computed(() => store.getters["auth/isQCUser"]);
const isBookingManagement = computed(
  () => store.getters["auth/isBookingManagement"]
);
const statecurrentdate = computed(() => store.getters["diary/currentdate"]);
const booking = computed(() => store.getters["diary/booking"]);
const inspectors = computed(() => store.getters["diary/inspectorlist"]);
const reportTypes = computed(() => store.getters["dictionary/reportTypes"]);
const jobtypelist = computed(() => store.getters["diary/jobtypelist"]);
const jobtypeslug = computed(() => store.getters["diary/jobtype"]);
const offactreporttypes = computed(
  () => store.getters["diary/offactreporttypes"]
);
const internaljobtypeslug = computed(
  () => store.getters["diary/internaljobtype"]
);
const jobtypemap = computed(() => store.getters["diary/jobtypemap"]);
const startdate = computed(() => store.getters["diary/startdate"]);
const enddate = computed(() => store.getters["diary/enddate"]);
const appointmenttime = computed(() => store.getters["diary/appointmenttime"]);
const _cleaningnotes = computed(() => store.getters["diary/cleaningnotes"]);
const propertytypelist = computed(
  () => store.getters["diary/propertytypelist"]
);
const propertyspec = computed(
  (): PropertySpec => store.getters["diary/propertyspec"]
);
const address = computed(() => store.getters["diary/address"]);
const emaillogs = computed(() => store.getters["diary/emaillogs"]);
const systemproperties = computed(
  () => store.getters["dictionary/systemproperties"]
);
const internaljobtypedisplayname = computed(
  (): Map<string, string> => store.getters["diary/internaljobtypedisplayname"]
);
const removeRequest = (id: string) => store.commit("app/removeRequest", id);
const setCurrentdate = (currentdate: Date) =>
  store.commit("diary/setCurrentdate", currentdate);
const setJobtype = (type: DictionaryReportType) =>
  store.commit("diary/setJobtype", type);
const setInternaljobtype = (jobtype: string) => {
  store.commit("diary/setInternaljobtype", jobtype);
};
const setBooking = (booking: Booking) =>
  store.commit("diary/setBooking", booking);
const setStartdate = (startdate: string) =>
  store.commit("diary/setStartdate", startdate);
const setEnddate = (enddate: string) =>
  store.commit("diary/setEnddate", enddate);
const setAppointmenttime = (appointmenttime: string) =>
  store.commit("diary/setAppointmenttime", appointmenttime);
const setPaymentdate = (paymentdate: string) =>
  store.commit("diary/setPaymentdate", paymentdate);
const setPostcodeReports = (reports: Report[]) =>
  store.commit("reports/setPostcodeReports", reports);
const setPostcodeBookings = (reports: Booking[]) =>
  store.commit("diary/setPostcodeBookings", reports);
const resetUnsavedChanges = () => store.commit("diary/resetUnsavedChanges");
const setCurrentEmailLog = (log: EmailLog) =>
  store.commit("diary/setCurrentEmailLog", log);

const sortInpectorsInState = (params: {
  previousreport: Report;
  previousbooking: Booking;
  postcode: string;
}) => store.dispatch("diary/sortInpectors", params);
const generateReportPdfAction = (report: Report) =>
  store.dispatch("reports/generateReportPdf", report);
const generateReportSummaryPdfAction = (report: Report) =>
  store.dispatch("reports/generateReportSummaryPdf", report);
const getBookings = (payload?: { date?: string }) =>
  store.dispatch("diary/getBookings", payload);
const setBookingDeep = (payload: { path: string; data: any }) =>
  store.dispatch("diary/setBookingDeep", payload);
const setAddressDeep = (payload: { path: string; data: any }) =>
  store.dispatch("diary/setAddressDeep", payload);
const setPropertyspecDeep = (payload: { path: string; data: any }) =>
  store.dispatch("diary/setPropertyspecDeep", payload);
const searchReports = (postcode: string) =>
  store.dispatch("reports/searchReports", postcode);
const searchGetaddressByPostcode = (postcode: string) =>
  store.dispatch("diary/searchGetaddressByPostcode", postcode);
const searchGetaddressByAddress = (postcode: string) =>
  store.dispatch("diary/searchGetaddressByAddress", postcode);
const getEmailLogs = (bookingid: string) =>
  store.dispatch("diary/getEmailLogs", bookingid);
const searchBookings = (params) =>
  store.dispatch("diary/searchBookings", params);
const reorderedinternaljobtypelist = ref([]);

const numberofroomsoptions = ref([
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
]);
const furnishedOptions = ref([
  "Unfurnished",
  "Part furnished",
  "Fully furnished",
  "Fully furnished with linen",
]);
onMounted(() => {
  if (currentdate.value && currentdatewatch.value !== '2050-12-31') {
    getBookings({
      date: formatDate(currentdate.value),
    });
  }
});

const currentdate = computed({
  get: () => statecurrentdate.value,
  set: (val: Date) => setCurrentdate(val),
});
const currentdatewatch = computed(() =>
  moment(currentdate.value).format("YYYY-MM-DD")
);

watch(
  () => currentdatewatch.value,
  () => {
    if (currentdate.value && currentdatewatch.value !== '2050-12-31') {
      getBookings({ date: formatDate(currentdate.value) }).then(() =>
        sortInspectors()
      );
    }
  }
);

const jobtypeoptions = computed((): DictionaryReportType[] => {
  let list = jobtypelist.value.map((jt: string) => {
    let dictionaryReportType: DictionaryReportType | undefined =
      reportTypes.value.find((type: DictionaryReportType) => type.slug === jt);
    if (!dictionaryReportType) {
      dictionaryReportType = prepareDictionaryReportType(jt);
    }
    return dictionaryReportType;
  });
  return list;
});

const prepareDictionaryReportType = (val: string): DictionaryReportType => {
  let type = new DictionaryReportType();
  if (val) {
    let name = val
      .split(" ")
      .map((word) => {
        return word[0].toUpperCase() + word.substring(1);
      })
      .join(" ");
    return DictionaryReportType.parse({
      id: val,
      slug: val,
      name: name,
      displayname: name,
      createallowed: false,
      dictionaryflag: false,
    });
  }
  return type;
};

const jobtype = computed({
  get: (): DictionaryReportType | undefined => {
    let type: DictionaryReportType | undefined;
    if (dictionary.value && dictionary.value.reporttypes) {
      type = dictionary.value.reporttypes.find(
        (t) => t.slug === jobtypeslug.value
      );
    }
    if (!type) type = prepareDictionaryReportType(jobtypeslug.value);
    return type;
  },
  set: (value: DictionaryReportType | undefined) => {
    if (value) {
      setJobtype(value);
      if (value.slug === "checkout") {
        if (
          booking.value.previousbooking?.id ||
          booking.value.previousreport?.id
        ) {
          setInternaljobtype("Check-Out - off ACT report");
        } else if (
          booking.value.previousreport &&
          !booking.value.previousreport.id
        ) {
          setInternaljobtype("Check-Out - off upload");
        }
      }
    }
  },
});

const internaljobtype = computed({
  get: (): string => internaljobtypeslug.value,
  set: (value: string) => setInternaljobtype(value),
});

watch(
  () => jobtype.value,
  (newValue: any, oldValue: any) => {
    if (!oldValue || (newValue && newValue.slug != oldValue.slug)) {
      if (jobtype.value) {
        let templist = jobtypemap.value.get(jobtype.value?.slug);
        if (jobtype.value.slug === "checkin") {
          if (
            booking.value.previousbooking?.id &&
            booking.value.previousbooking.internaljobtype ===
              "Check-Out - off upload"
          ) {
            // Remove "Check-In - off ACT report"
            templist = [
              "Check In - last CO, from upload",
              "Check-In - back to back",
            ];
          } else {
            // Remove "Check-In - off upload",
            templist = ["Check-In - off ACT report", "Check-In - back to back"];
          }
        }
        if (templist) reorderedinternaljobtypelist.value = templist;

        if (
          reorderedinternaljobtypelist.value &&
          reorderedinternaljobtypelist.value.length == 1
        ) {
          setInternaljobtype(reorderedinternaljobtypelist.value[0]);
        }
        let index = reorderedinternaljobtypelist.value.indexOf(
          internaljobtype.value
        );
        if (index < 0) setInternaljobtype("");
      }

      if (
        !booking.value.id &&
        booking.value?.previousbooking?.id &&
        !oldValue.slug
      ) {
        // First time setting jobtype on a new booking
        // If converting from old booking, apply conversion rules

        // Exclude back-to-back CI, this will be done under @Watch("internaljobtype")
        if (newValue?.slug != "checkin") {
          if (booking.value?.previousbooking?.inspector?.id) {
            // This is just to load fully loaded inspector object inside previous booking
            // This is later used to terermine timing of the booking
            fullloadInspector(booking.value.previousbooking);
          }
          convert(booking.value.previousbooking, booking.value, setBookingDeep);
        }
      }
    }
  }
);

const applycommonconversionrules = (selectedbooking: Booking) => {
  convertcommon(selectedbooking, booking.value, setBookingDeep);
  channel.publish("commoncovertapplied", {
    deviceid: deviceid,
    bookingid: booking.value.id,
  });
};
const googlebookingselected = (selectedbooking: Booking) => {
  const modal = bookingDetailModal.value as any;
  modal.init(selectedbooking);
  modal.show();
};

watch(
  () => internaljobtype.value,
  () => {
    // Only process back-to-back CI, rest will be taken care under @Watch("jobtype")
    if (isNewBooking() && jobtype.value?.slug === "checkin") {
      if (booking.value?.previousbooking?.inspector?.id) {
        // This is just to load fully loaded inspector object inside previous booking
        // This is later used to terermine timing of the booking
        fullloadInspector(booking.value.previousbooking);
      }
      if (booking.value?.previousbooking?.id) {
        convert(booking.value.previousbooking, booking.value, setBookingDeep);
        if (booking.value.internaljobtype === Booking.B2BCI) {
          setCurrentdate(booking.value.previousbooking.startdateAsDate);
        }
      }
    }
  }
);

const fullloadInspector = (book: Booking) => {
  let inspector: Inspector | undefined = inspectors.value.find(
    (i: Inspector) => i.id === booking.value.previousbooking.inspector.id
  );
  if (inspector?.id) book.inspector = new Inspector(inspector);
};

const setBookingDate = (e: any) => {
  let selecteddate = formatDate(e.value);
  let currentstartdate = formatDate(booking.value.startdateAsDate);
  let bookingdate = moment(e.value).utc().format(actProperty.bookingdateformat);
  setStartdate(postfixUTCTime(bookingdate, startdate.value));
  setEnddate(postfixUTCTime(bookingdate, enddate.value));
  if(appointmenttime.value)
    setAppointmenttime(postfixUTCTime(bookingdate, appointmenttime.value));
  setPaymentdate(bookingdate);

  channel.publish("currentdateChanged", {
    deviceid: deviceid,
    bookingdate: bookingdate,
    newbooking: isNewBooking(),
    postcode: postcode.value,
  });
  if (booking.value.id && currentstartdate != selecteddate) {
    // If this is an existing booking, unlock the appointmenttime
    // Reset all communication flags
    // We essentially need to resend all notifications
    setBookingDeep({ path: "emaillogs.clientconfirmationsentdate", data: "" });
    setBookingDeep({ path: "emaillogs.tenantconfirmationsentdate", data: "" });
    setBookingDeep({ path: "emaillogs.dataentryconfirmationsentdate", data: "" });
    setBookingDeep({
      path: "emaillogs.landlordconfirmationsentdate",
      data: "",
    });
    setBookingDeep({
      path: "emaillogs.tenantconfirmationreceiveddate",
      data: "",
    });
    setBookingDeep({ path: "smslogs.tenantconfirmationsentdate", data: "" });
    setBookingDeep({
      path: "smslogs.tenantconfirmationreceiveddate",
      data: "",
    });
    setBookingDeep({ path: "preferredappointmenttime", data: 0 });
    setBookingDeep({ path: "tenantattending", data: "unsure" });
    //https://trello.com/c/GgMBtP84/764-1-access-via-tt-toggle-reset-when-date-changed
    setBookingDeep({ path: "confirmaccess", data: false});
    booking.value.tenantsarray.forEach((obj:Tenant) => obj.attending = "");
    setBookingDeep({ path: "tenants", data: booking.value.tenantsarray});
    showDateChangeReminderModal();
  }
};

const isNewBooking = () => {
  return route.params.id == "new";
};

const formatDate = (date: Date) => {
  return moment(date).format("DD-MM-YYYY");
};

const cleaningnotes = computed({
  get: () => _cleaningnotes.value,
  set: (val) => setBookingDeep({ path: "cleaningnotes", data: val }),
});

const line1 = computed({
  get: () => address.value.line1,
  set: (data) => setAddressDeep({ path: "line1", data }),
});

const line2 = computed({
  get: () => address.value.line2,
  set: (data) => setAddressDeep({ path: "line2", data }),
});

const town = computed({
  get: () => address.value.town,
  set: (data) => setAddressDeep({ path: "town", data }),
});

const postcode = computed({
  get: () => address.value.postcode,
  set: (val: string) => {
    setAddressDeep({ path: "postcode", data: val.toString().toUpperCase() });
  },
});

const county = computed({
  get: () => address.value.county,
  set: (data) => setAddressDeep({ path: "county", data }),
});

const propertytype = computed({
  get: () => propertyspec.value.propertytype,
  set: (data) => setPropertyspecDeep({ path: "propertytype", data }),
});
const setPropertytype = (data: string) => {
  setPropertyspecDeep({ path: "propertytype", data });
};

const bedrooms = computed({
  get: () => propertyspec.value.bedrooms,
  set: (data) => setPropertyspecDeep({ path: "bedrooms", data }),
});

const bathrooms = computed({
  get: () => propertyspec.value.bathrooms,
  set: (data) => setPropertyspecDeep({ path: "bathrooms", data }),
});

const receptions = computed({
  get: () => propertyspec.value.receptions,
  set: (data) => setPropertyspecDeep({ path: "receptions", data }),
});

const other = computed({
  get: () => propertyspec.value.other,
  set: (data) => setPropertyspecDeep({ path: "other", data }),
});

const sqft = computed({
  get: () => propertyspec.value.sqft,
  set: (data) => setPropertyspecDeep({ path: "sqft", data }),
});

const floorplan = computed({
  get: () => propertyspec.value.floorplan,
  set: (data) => setPropertyspecDeep({ path: "floorplan", data }),
});
const showFloorplanDocument = (index: number) => {
  emit("showfloorplandocument", index);
};

const furnished = computed({
  get: () => propertyspec.value.furnished,
  set: (data) => setPropertyspecDeep({ path: "furnished", data }),
});
const setFurnished = (data: string) => {
  setPropertyspecDeep({ path: "furnished", data });
};

const provisional = computed({
  get: () => booking.value.provisional,
  set: (data) => setBookingDeep({ path: "provisional", data }),
});
const provisionalnotes = computed({
  get: () => booking.value.provisionalnotes,
  set: (data) => setBookingDeep({ path: "provisionalnotes", data }),
});

const removepreviousreport = () => {
  setBookingDeep({ path: "previousreport", data: new Report() });
  setBookingDeep({ path: "previousbooking", data: new Booking() });
  // https://trello.com/c/7sCyIhnK/748-ability-to-clear-previous-report-details
  // Added Bilal Patel
  setBookingDeep({ path: "dataentryreport", data: new Report() });
};

const sortInspectors = () => {
  sortInpectorsInState({
    previousreport: booking.value?.basereport,
    previousbooking: booking.value?.previousbooking,
    postcode: postcode.value,
  });
};

const addressSearch = ($event: any) => {
  let address = $event.target.value;
  searchReports(address);
  search(address);
  const modal = cmsSearchModal.value;
  modal.init();

  searchGetaddressByAddress(address)
    .then((response) => {
      const list = processGetAddressResponse(response);
      setPostcodeReports(list);
    })
    .catch(() => setPostcodeReports([]));
  modal.show();
};

const postcodeSearch = ($event: any) => {
  let postcode = $event.target.value.toUpperCase();
  searchReports(postcode);
  search(postcode);
  const modal = cmsSearchModal.value;
  modal.init();

  searchGetaddressByPostcode(postcode)
    .then((response) => {
      const list = processGetPostcodeResponse(response);
      list.forEach((r) => (r.address.postcode = postcode));
      setPostcodeReports(list);
    })
    .catch(() => setPostcodeReports([]));
  modal.show();
  channel.publish("postcodeSearch", {
    postcode,
    deviceid: deviceid,
    newbooking: isNewBooking(),
  });
};

const search = (val: string) => {
  searchBookings({ anytext: val, cancelled: "false", sort: "created_at", limit: 100 }).then((bookings) => {
    bookings.sort((b1: Booking, b2: Booking) => {
      if (moment.utc(b1.startdate).isAfter(moment.utc(b2.startdate))) {
        return -1;
      } else if (moment.utc(b1.startdate).isBefore(moment.utc(b2.startdate))) {
        return 1;
      } else {
        return 0;
      }
    });
    setPostcodeBookings(bookings);
  });
};

const processGetPostcodeResponse = (response: GetaddressResponse) => {
  return response.addresses.map((address) => {
    let splitaddressarray = address.split(",");
    let report = new Report();
    report.address = new Address({
      line1: splitaddressarray[0],
      line2: splitaddressarray[1],
      town: splitaddressarray[5],
    });
    return report;
  });
};

const processGetAddressResponse = (response: SearchAddressResponse) => {
  return response.addresses.map((address) => {
    let splitaddressarray = address.split(",");
    let report = new Report();
    report.address = new Address({
      line1: splitaddressarray[0],
      line2: splitaddressarray[1],
      town: splitaddressarray[2],
    });
    return report;
  });
};

const offupload = computed(() => {
  return (
    internaljobtype.value && internaljobtype.value === "Check-Out - off upload"
  );
});

const previousreportpi = computed(() => {
  let pi = booking.value.previousreportpi;
  if (pi) pi = `PI: ${pi}`;
  return pi;
});

const previousreportcleanliness = computed(() => {
  let cleanliness = "";
  if (
    booking.value?.basereport &&
    booking.value.basereport.propertyDetails &&
    booking.value.basereport.propertyDetails.generalNotes
  ) {
    let indexa =
      booking.value.basereport.propertyDetails.generalNotes.indexOf(
        "Cleanliness"
      );
    let indexb =
      booking.value.basereport.propertyDetails.generalNotes.indexOf("\n");
    if (indexa >= 0 && indexb >= 0) {
      cleanliness =
        booking.value.basereport.propertyDetails.generalNotes.substring(
          indexa,
          indexb
        );
    }
  }
  return cleanliness;
});

const previousreportitemcount = computed(() => {
  let itemcount = 0;
  if (booking.value?.basereport && booking.value.basereport.rooms) {
    booking.value.basereport.rooms.forEach((r) => {
      r.sections.forEach((s) => {
        s.types.forEach((t) => {
          itemcount += t.items.length;
        });
      });
    });
  }
  return itemcount ? "Item count: " + itemcount : "";
});

const previousreportref = computed(() => {
  return booking.value?.basereport?.ref;
});

watch(
  () => previousreportref.value,
  () => {
    sortInspectors();
  }
);

watch(
  () => postcode.value,
  () => {
    if (!isNewBooking()) {
      channel.publish("postcodeSearch", {
        postcode: postcode.value,
        deviceid: deviceid,
        newbooking: false,
      });
    } else if (!postcode.value) {
      channel.publish("postcodeSearch", {
        postcode: postcode.value,
        deviceid: deviceid,
        newbooking: true,
      });
    }
  }
);

const showDataentryDocument = (index: number) => {
  emit("showdataentrydocument", index);
};

const dataentrydocumentadded = () => {
  // Add new report for dataentry
  /*let dataentryreport = new Report();
  dataentryreport.type = "inventory";
  dataentryreport.address = new Address(booking.value.address);
  dataentryreport.address.line1 = "UPLOAD " + booking.value.address.line1;
  addDataentryReport(dataentryreport)
    .then((report: Report) => {
      this.setDataentryreport(report);
      toasted.success(`Report entry created for dataentry`);
    })
    .catch((err: any) => actProperty.displayError(err));*/
};

const dataentryreportitemcount = computed(() => {
  let itemcount = 0;
  if (booking.value?.dataentryreport && booking.value?.dataentryreport?.rooms) {
    booking.value?.dataentryreport.rooms.forEach((r: Room) => {
      r.sections.forEach((s: Section) => {
        s.types.forEach((t: Type) => {
          itemcount += t.items.length;
        });
      });
    });
  }
  return itemcount ? "Item count: " + itemcount : "";
});

/**
 * Generate INV/CI/CO Report PDF
 */
const generateReportPdf = (report: Report, requestId: string): void => {
  generateReportPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
};

/**
 * Generate COSM Report PDF
 */
const generateReportSummaryPdf = (report: Report, requestId: string): void => {
  generateReportSummaryPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} Summary PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
};

const customLabelForReportType = (type: DictionaryReportType) => {
  return type.displayname;
};
const customLabelForInternaljobtype = (internaljobtype: string): string => {
  return actProperty.customLabelForInternaljobtype(
    internaljobtypedisplayname.value,
    internaljobtype
  );
};

const previousreportotherroomlist = computed(() => {
  let list: string[] = [];
  if (
    booking.value &&
    booking.value?.basereport &&
    booking.value?.basereport?.rooms
  ) {
    let roomtypes: string[] = ["bedroom", "bathroom", "ensuite", "reception"];
    list = booking.value?.basereport?.rooms
      .filter((r) => {
        let index = roomtypes.findIndex((type: string) => type === r.type);
        return index < 0;
      })
      .map((room: Room) => room.name);
  }
  return list;
});

const showAddressChangedWarning = (field: string) => {
  if (isBookingManagement.value || isQCuser.value) return;
  // Don't show alert for a new booking
  if (!booking.value.id) return;

  const modal = alertDialog.value as any;
  if (modal) {
    modal.init(
      "Warning",
      "If you change the address of this booking, you are overriding an existing booking",
      "Yes, I understand",
      "",
      field
    );
    modal.show();
  }
};

const showIncorrectEntrySelectedFromAddressSearchWarning = (field: string) => {
  if (isBookingManagement.value || isQCuser.value) return;
  const modal = alertDialog.value as any;
  if (modal) {
    modal.init(
      "Warning",
      "You have selected a property address from postcode search, but the same property already exists on our system. You should select from either list of old reports or bookings",
      "Yes, I understand",
      "",
      field
    );
    modal.show();
  }
};

const showDateChangeReminderModal = () => {
  if (isBookingManagement.value || isQCuser.value) return;
  // Don't show reminder for a new booking
  if (!booking.value.id) return;

  const modal = alertDialog.value as any;
  if (modal) {
    modal.init(
      "Reminder",
      "Please inform TT of the new date.",
      "Got it",
      "",
      "reminder"
    );
    modal.show();
  }
};

const prepadate = computed(() => {
  let pdate = "";
  if (prepsubbooking.value) {
    pdate = prepsubbooking.value.bookingdate;
  }
  return pdate;
});
const prepsubbooking = computed(() => {
  let sub: Booking | undefined = undefined;
  if (booking.value.subbookings?.length) {
    sub = booking.value.subbookings.find(
      (b: Booking) => b.subtype === Booking.PREP
    );
  }
  return sub;
});

const showTooltip = () => {
  let tooltip = otherroomstooltip.value as any;
  tooltip.instance.show();
  tooltip.instance.repaint();
};
const hideTooltip = () => {
  let tooltip = otherroomstooltip.value as any;
  tooltip.instance.hide();
};

const otherroomstooltipHtml = computed(() => {
  let tiptext = `<div class="text-left">`;
  previousreportotherroomlist.value.forEach(
    (room: string) => (tiptext = `${tiptext}${room}<br/>`)
  );
  return `${tiptext}</div>`;
});

const unlockBooking = async (booking: Booking) => {
  if (booking && booking.id) {
    await store.dispatch("diary/unlockBooking", booking).then((b: Booking) => {
      channel.publish("bookingunlocked", { bookingid: b.id });
    });
  }
};

const resetForm = () => {
  if (hasUnsavedChanges.value) {
    let confirm = actProperty.confirmPrompt(
      "You have unsaved changes. Do you want to continue without saving your changes?"
    );
    confirm
      .then(() => {
        unlockBooking(booking.value);
        resetUnsavedChanges();
        const newbooking = initnewbooking();
        setBooking(newbooking);
        channel.publish("unselectBooking", { deviceid: deviceid });
        router.push("/diary/new").catch((err) => {});
      })
      .catch((err) => actProperty.displayError(err));
  } else {
    unlockBooking(booking.value);
    const newbooking = initnewbooking();
    setBooking(newbooking);
    channel.publish("unselectBooking", { deviceid: deviceid });
    router.push("/diary/new").catch((err) => {});
  }
};

const initnewbooking = () => {
  const invoice = new Report({ fees: [new Fee()] });
  const booking = new Booking({ invoices: [invoice] });
  currentdate.value =   moment()
      .utc()
      .toDate();
  setCurrentdate(currentdate.value);
  const fiveam = moment(currentdate.value)
    .utc()
    .startOf("day")
    .add(5, "hours")
    .format(actProperty.bookingDateFormat);
  booking.startdate = fiveam;
  booking.enddate = fiveam;
  booking.appointmenttime = fiveam;
  return booking;
};

const currentdatesameastoday = () => {
  return moment(currentdate.value).isSame(new Date(), "day");
};

const fromaddress = computed(() => {
  let prop = systemproperties.value.find(
    (sp) => sp.propertykey === "booking.email.fromaddress"
  );
  return prop ? prop?.value : "";
});

const dataentryemailaddress = computed(() => {
  let prop = systemproperties.value.find(
    (sp) => sp.propertykey === "dataentry.email"
  );
  let emailaddresses = [];
  if (prop && prop.value) {
    emailaddresses = prop.value.split(",");
  }
  return emailaddresses.filter((e) => e);
});

const ccaddresses = computed(() => {
  let prop = systemproperties.value.find(
    (sp) => sp.propertykey === "booking.email.ccaddress"
  );
  return prop ? [prop.value] : [];
});

const bccaddresses = computed(() => {
  let prop = systemproperties.value.find(
    (sp) => sp.propertykey === "booking.email.bccaddress"
  );
  return prop ? [prop.value] : [];
});

const showDataentryConfirmationModal = () => {
  if (booking.value.dataentryreport?.ref) {
    const modal = dataentryconfirmationEmailModal.value;
    modal.init();

    modal.show();
  } else {
    const modal = alertDialog.value;
    modal.init(
      "Warning",
      "Please save the booking first and then try to send email confirmation",
      "Ok"
    );
    modal.show();
  }
};

const showDataentryEmailLogsModal = () => {
  const modal = dataentryconfirmationEmailLogsModal.value as any;
  getEmailLogs(booking.value.id);
  if (emaillogs.value?.dataentryemaillogs?.length)
    setCurrentEmailLog(emaillogs.value.dataentryemaillogs[0]);
  else setCurrentEmailLog(new EmailLog());
  modal.show();
};

const clearJobtype = () => {
  setJobtype(new DictionaryReportType());
};
const bookingTitle = (booking: Booking) => {
  let bookingtitle = actProperty.getBookingTitle(booking, dictionary.value);
  if (booking.jobtype && booking.titlenotes) {
    bookingtitle = `${bookingtitle}: ${booking.titlenotes}`;
  } else {
    bookingtitle = `${bookingtitle}`;
  }
  return bookingtitle;
};

const prepandKeyJobData = computed(() => {
  let prepandKeyJob = booking.value.subbookings.filter(
    (f: any) => f.subtype === "Prep" || f.subtype === "Key"
  );
  return prepandKeyJob;
});

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-header booking-section-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, [
      _createElementVNode("div", { class: "row" }, [
        _hoisted_2,
        _createElementVNode("div", { class: "col-md-3 text-right" }, [
          _createElementVNode("button", {
            type: "button",
            class: "close ml-auto p-1 pl-2 pr-2",
            "aria-label": "Close",
            style: {"color":"white"},
            onClick: resetForm
          }, _hoisted_4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control height-43",
                style: {"min-width":"100px"},
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((postcode).value = $event)),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showAddressChangedWarning('postcode')), ["stop"])),
                onChange: sortInspectors,
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (postcodeSearch($event)), ["enter"])),
                ref: (el) => (dynamicRefs.value['postcode'] = el),
                autocomplete: "off"
              }, null, 544), [
                [
                  _vModelText,
                  postcode.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((line1).value = $event)),
                autocomplete: "addressline1",
                ref: (el) => (dynamicRefs.value['line1'] = el),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showAddressChangedWarning('line1'))),
                onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (addressSearch($event)), ["enter"]))
              }, null, 544), [
                [
                  _vModelText,
                  line1.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((line2).value = $event)),
                ref: (el) => (dynamicRefs.value['line2'] = el),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (showAddressChangedWarning('line2'))),
                autocomplete: "addressline2"
              }, null, 512), [
                [
                  _vModelText,
                  line2.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((town).value = $event)),
                ref: (el) => (dynamicRefs.value['town'] = el),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (showAddressChangedWarning('town'))),
                autocomplete: "addresstown"
              }, null, 512), [
                [
                  _vModelText,
                  town.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((county).value = $event)),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (showAddressChangedWarning('county'))),
                ref: (el) => (dynamicRefs.value['county'] = el),
                autocomplete: "addresscounty"
              }, null, 512), [
                [
                  _vModelText,
                  county.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, [
                _createVNode(_component_singleselect_text, {
                  modelValue: jobtype.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((jobtype).value = $event)),
                  options: jobtypeoptions.value,
                  "custom-label": customLabelForReportType,
                  "allow-empty": false,
                  taggable: false
                }, _createSlots({ _: 2 }, [
                  (jobtype.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (clearJobtype()), ["prevent","stop"])),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Job Type"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: internaljobtype.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((internaljobtype).value = $event)),
                    options: reorderedinternaljobtypelist.value,
                    "custom-label": customLabelForInternaljobtype,
                    "allow-empty": false,
                    taggable: false,
                    disabled: !jobtype.value || jobtype.value.slug == '',
                    class: _normalizeClass({ outline: prepsubbooking.value })
                  }, _createSlots({
                    option: _withCtx((props) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({'strikethrought': booking.value?.previousbooking && booking.value?.previousbooking?.id && (props.option === 'Inv CI - new to ACT' || props.option === 'Inv CI - old report on file, charge CI rate')})
                      }, _toDisplayString(props.option), 3)
                    ]),
                    _: 2
                  }, [
                    (internaljobtype.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (setInternaljobtype('')), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Internal Job Type"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options", "disabled", "class"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", {
                class: _normalizeClass({ outline: currentdatesameastoday() })
              }, [
                _createVNode(_unref(DxDateBox), {
                  modelValue: currentdate.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((currentdate).value = $event)),
                  onValueChanged: setBookingDate,
                  "display-format": "dd/MM/yyyy",
                  type: "date",
                  "picker-type": "calendar",
                  calendarOptions: { firstDayOfWeek: 1, showTodayButton: true },
                  "apply-value-mode": "instantly"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DxDateBoxButton), { name: "dropDown" })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (currentdatesameastoday())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Date has not been changed "))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_singleselect_text, {
                    options: numberofroomsoptions.value,
                    "allow-empty": true,
                    taggable: false,
                    modelValue: bedrooms.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((bedrooms).value = $event)),
                    modelModifiers: { lazy: true }
                  }, null, 8, ["options", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_singleselect_text, {
                    options: numberofroomsoptions.value,
                    "allow-empty": true,
                    taggable: false,
                    modelValue: bathrooms.value,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((bathrooms).value = $event)),
                    modelModifiers: { lazy: true }
                  }, null, 8, ["options", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_singleselect_text, {
                    options: numberofroomsoptions.value,
                    "allow-empty": true,
                    taggable: false,
                    modelValue: receptions.value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((receptions).value = $event)),
                    modelModifiers: { lazy: true }
                  }, null, 8, ["options", "modelValue"])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-md-2", { 'pr-0': previousreportotherroomlist.value.length }])
                }, [
                  _hoisted_41,
                  _createVNode(_component_singleselect_text, {
                    options: numberofroomsoptions.value,
                    "allow-empty": true,
                    taggable: false,
                    modelValue: other.value,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((other).value = $event)),
                    modelModifiers: { lazy: true }
                  }, _createSlots({
                    singleLabel: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_42, [
                        (props.option > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(props.option), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_44))
                      ])
                    ]),
                    _: 2
                  }, [
                    (previousreportotherroomlist.value.length)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              id: "previousreportotherroomlisttooltip",
                              class: "multiselect__clear fa fa-question",
                              onMouseenter: showTooltip,
                              onMouseleave: hideTooltip
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["options", "modelValue"]),
                  _createVNode(_unref(DxTooltip), {
                    ref_key: "otherroomstooltip",
                    ref: otherroomstooltip,
                    "hide-on-outside-click": false,
                    target: "#previousreportotherroomlisttooltip",
                    contentTemplate: otherroomstooltipHtml.value
                  }, null, 8, ["contentTemplate"])
                ], 2),
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("span", null, [
                    _hoisted_47,
                    (_openBlock(), _createBlock(FloorplanComponent, {
                      key: floorplan.value.length,
                      floorplan: floorplan.value,
                      path: 'floorplan',
                      onClicked: showFloorplanDocument
                    }, null, 8, ["floorplan"]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    class: "form-control height-43",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((sqft).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      sqft.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", null, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: propertytype.value,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((propertytype).value = $event)),
                      options: propertytypelist.value,
                      "allow-empty": true,
                      taggable: false
                    }, _createSlots({ _: 2 }, [
                      (propertytype.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (setPropertytype('')), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Property Type"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", null, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: furnished.value,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((furnished).value = $event)),
                      options: furnishedOptions.value,
                      "allow-empty": true,
                      taggable: false
                    }, _createSlots({ _: 2 }, [
                      (furnished.value)
                        ? {
                            name: "clear",
                            fn: _withCtx(() => [
                              _createElementVNode("i", {
                                onMousedown: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (setFurnished('')), ["prevent","stop"])),
                                class: "multiselect__clear fa fa-times",
                                "aria-label": "Clear Furnished"
                              }, null, 32)
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue", "options"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_unref(DxSwitch), {
                          value: provisional.value,
                          onValueChanged: _cache[27] || (_cache[27] = ($event: any) => (provisional.value = $event.value))
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  (booking.value.provisional)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          rows: "1",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((provisionalnotes).value = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            provisionalnotes.value,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value.jobtype && booking.value.internaljobtype)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        (offupload.value)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_63, "Notes (based on uploaded report)"))
                          : (
                        offactreporttypes.value.includes(booking.value.internaljobtype)
                      )
                            ? (_openBlock(), _createElementBlock("label", _hoisted_64, "Notes (based on previous report notes)"))
                            : _createCommentVNode("", true),
                        (
                        offupload.value ||
                        offactreporttypes.value.includes(booking.value.internaljobtype)
                      )
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 2,
                              class: "form-control",
                              rows: "5",
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((cleaningnotes).value = $event))
                            }, null, 512)), [
                              [
                                _vModelText,
                                cleaningnotes.value,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  (prepandKeyJobData.value && prepandKeyJobData.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepandKeyJobData.value, (prepdata, $prepdata) => {
                          return (_openBlock(), _createElementBlock("div", { key: $prepdata }, [
                            _createElementVNode("ul", _hoisted_67, [
                              _createElementVNode("li", null, [
                                _createElementVNode("span", _hoisted_68, [
                                  _createElementVNode("h5", null, _toDisplayString(bookingTitle(prepdata)) + ":", 1),
                                  _createElementVNode("span", _hoisted_69, _toDisplayString(prepdata.inspector.name), 1)
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("span", _hoisted_70, [
                                  _hoisted_71,
                                  (prepdata?.startdate || prepdata?.enddate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(prepdata.bookingdate) + " - " + _toDisplayString(prepdata.starttime) + " to " + _toDisplayString(prepdata.endtime), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (
                            prepdata.subtype === 'Prep' &&
                            booking.value.invoices?.length > 0 &&
                            booking.value.invoices[0].firstexportedby
                          )
                                ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                                    _createElementVNode("span", _hoisted_74, [
                                      _hoisted_75,
                                      _createElementVNode("span", _hoisted_76, _toDisplayString(booking.value.invoices[0].ref), 1)
                                    ]),
                                    (
                              booking.value?.invoices[0]?.propertyDetails
                                ?.generalNotes
                            )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                          _hoisted_78,
                                          _createElementVNode("span", {
                                            class: "ml-1",
                                            innerHTML: 
                                booking.value?.invoices[0]?.propertyDetails
                                  .generalNotes
                              
                                          }, null, 8, _hoisted_79)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (booking.value.basereport && booking.value.basereport.ref)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                        _createElementVNode("ul", _hoisted_81, [
                          _createElementVNode("li", null, [
                            _hoisted_82,
                            _createElementVNode("button", {
                              type: "button",
                              class: "close",
                              "aria-label": "Clear"
                            }, [
                              _createElementVNode("span", {
                                "aria-hidden": "true",
                                onClick: removepreviousreport
                              }, "×")
                            ])
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(actProperty).formatReportType(
                          booking.value.basereport.type,
                          dictionary.value
                        )) + " " + _toDisplayString(_unref(actProperty).formatDateForDisplay(
                              booking.value.basereport.date
                            )), 1)
                          ]),
                          _createElementVNode("li", null, "Ref: " + _toDisplayString(booking.value.basereport.ref), 1),
                          (previousreportpi.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_83, _toDisplayString(previousreportpi.value), 1))
                            : _createCommentVNode("", true),
                          (previousreportcleanliness.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_84, _toDisplayString(previousreportcleanliness.value), 1))
                            : _createCommentVNode("", true),
                          (previousreportitemcount.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_85, _toDisplayString(previousreportitemcount.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createVNode(ProgressButton, {
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (
                            _unref(actProperty).copyDownloadButton(
                              booking.value.basereport,
                              'report'
                            )
                          )),
                              onDblclick: _cache[31] || (_cache[31] = ($event: any) => (
                            generateReportPdf(booking.value.basereport, $event)
                          )),
                              class: "btn btn-outline-primary",
                              title: 
                            _unref(actProperty).formatReportType(
                              booking.value.basereport.type,
                              dictionary.value
                            )
                          
                            }, {
                              default: _withCtx(() => [
                                _hoisted_86,
                                _createTextVNode(" " + _toDisplayString(_unref(actProperty).formatReportType(
                              booking.value.basereport.type,
                              dictionary.value
                            )), 1)
                              ]),
                              _: 1
                            }, 8, ["title"]),
                            (booking.value.basereport.type == 'checkout')
                              ? (_openBlock(), _createBlock(ProgressButton, {
                                  key: 0,
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => (
                            _unref(actProperty).copyDownloadButton(
                              booking.value.basereport,
                              'summary'
                            )
                          )),
                                  onDblclick: _cache[33] || (_cache[33] = ($event: any) => (
                            generateReportSummaryPdf(booking.value.basereport, $event)
                          )),
                                  class: "btn btn-outline-primary",
                                  title: "Check-Out Summary"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_87,
                                    _createTextVNode(" Summary ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (
                    (!booking.value.previousreport || !booking.value.previousreport.ref) &&
                    offupload.value
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _hoisted_89,
                          (_openBlock(), _createBlock(Documents, {
                            buttontext: 'PDF',
                            entity: 'booking',
                            key: booking.value.dataentrydocuments.length,
                            documents: booking.value.dataentrydocuments,
                            path: 'dataentrydocuments',
                            onDocumentadded: dataentrydocumentadded,
                            onClicked: showDataentryDocument
                          }, null, 8, ["documents"]))
                        ])
                      ]),
                      (
                      booking.value.dataentryreport &&
                      booking.value.dataentryreport.ref &&
                      booking.value.dataentryreport.dataentrystatus ===
                        'Upload Complete'
                    )
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_90, [
                            _createElementVNode("li", null, "Ref: " + _toDisplayString(booking.value.dataentryreport.ref), 1),
                            (dataentryreportitemcount.value)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_91, _toDisplayString(dataentryreportitemcount.value), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (offupload.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: showDataentryConfirmationModal,
                          title: 'Send email to data entry'
                        }, [
                          (emaillogs.value.dataentryacknowledgementreceiveddate)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_95))
                            : (!emaillogs.value.dataentryconfirmationsentdate)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_96))
                              : (emaillogs.value.dataentryconfirmationsentdate)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_97))
                                : _createCommentVNode("", true),
                          _createTextVNode(" Email ")
                        ]),
                        (emaillogs.value.dataentryemaillogs.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-outline-secondary",
                              onClick: showDataentryEmailLogsModal
                            }, _hoisted_99))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(EmailModal, {
      id: `dataentry-email-confirmation-modal`,
      name: `dataentry-email-confirmation-modal`,
      ref_key: "dataentryconfirmationEmailModal",
      ref: dataentryconfirmationEmailModal,
      title: "Email notification to data entry",
      reporttype: "",
      target: "Data Entry",
      chronorder: "Initial confirmation",
      customer: "",
      fromaddress: fromaddress.value,
      toaddresses: dataentryemailaddress.value,
      label: "Data Entry"
    }, null, 8, ["fromaddress", "toaddresses"]),
    _createVNode(EmailLogsModal, {
      name: `dataentryconfirmation-emaillogs-modal`,
      ref_key: "dataentryconfirmationEmailLogsModal",
      ref: dataentryconfirmationEmailLogsModal,
      target: 'Data Entry',
      title: "Email Logs"
    }, null, 512),
    _createVNode(AlertDialog, {
      ref_key: "alertDialog",
      ref: alertDialog,
      name: "wwalertdialog"
    }, null, 512),
    _createVNode(BookingDetailModal, {
      id: "whatwhen-booking-detail-modal",
      ref_key: "bookingDetailModal",
      ref: bookingDetailModal
    }, null, 512),
    _createVNode(PostcodeReportSearchModal, {
      refname: 'cms-search-modal',
      ref_key: "cmsSearchModal",
      ref: cmsSearchModal,
      onPreviousbookingselected: applycommonconversionrules,
      onShowmatchingproperywarning: 
        showIncorrectEntrySelectedFromAddressSearchWarning
      ,
      onGooglebookingselected: googlebookingselected
    }, null, 8, ["onShowmatchingproperywarning"])
  ]))
}
}

})